import _ from "lodash";

const requireMixin = require.context(".", false, /\.js$/);

const mixins = {};

requireMixin.keys().forEach(fileName => {
  if (fileName === "./index.js") return;

  const mixinName = _.camelCase(fileName.replace(/(\.\/|\.js)/g, ""));

  mixins[mixinName] = {
    ...requireMixin(fileName).default,
  };
});

export default mixins;
